<template>
	<div @dblclick="openLayer">
		<slot/>
	</div>
</template>

<script>

import {layer} from "@layui/layer-vue";
import {routeList} from "@/router";
import {h} from "vue";

export default {
	name: "RouterDbLink",
	emits: ['success'],
	props: {
		to: Object,
		width: {
			type: String,
			default: "50vw"
		},
	},
	data() {
		return {
			title: ""
		}
	},
	methods: {
		openLayer() {
			let find = routeList.find(value => value.name === this.to.name);
			this.title = find.title;
			let layerId = layer.drawer({
				title: this.title,
				shadeClose: false,
				zIndex: 999,
				area: [this.width, '100vh'],
				content: h(find.component, Object.assign(this.to.params, {
					onSuccess: (args) => {
						this.$emit('success', args)
					},
					onClose: (args) => {
						layer.close(layerId);
					}
				})),
				onClose: (args) => {
					this.$emit('success', args)
				}
			});
		}
	},
}
</script>
